import { IQueryContext } from '../query-context/models/IQueryContext';

export const SQL_NOT_AVAILABLE = '';

export type DataLoaderResultStatus =
    | 'loading'
    | 'ok'
    | 'error'
    | 'unsupported-column';
/** An interface representing result generated in DataLoader's run funtion.
 * Contains data and metadata of a query.
 */

export interface IDataLoaderResult {
    data: any;
    /** queryContext of data fetch run */
    queryContext: IQueryContext;
    isLoading: boolean;
    status: DataLoaderResultStatus;
    statusMessage: string;
    sqlAndJsProcessing: string;
}

export class DataLoaderResult {
    public static getLoading<T>(
        data: T,
        queryContext: IQueryContext,
        sqlAndJsProcessing: string = SQL_NOT_AVAILABLE
    ): IDataLoaderResult {
        return {
            data,
            queryContext: structuredClone(queryContext),
            isLoading: true,
            status: 'loading',
            statusMessage: '',
            sqlAndJsProcessing,
        };
    }
}

export function mergeDataLoaderResultStatus(
    statuses: DataLoaderResultStatus[] // refactored to accept array
): DataLoaderResultStatus {
    if (statuses.includes('error')) {
        return 'error';
    }
    if (statuses.includes('unsupported-column')) {
        return 'unsupported-column';
    }
    if (statuses.includes('loading')) {
        return 'loading';
    }
    return 'ok';
}
